// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"499c719c","87":"fd766fbd","170":"529935b8","276":"98a3a632","346":"6113a19f","356":"ea2f2e04","379":"77d9a985","393":"92540492","521":"ab08140b","551":"01742129","680":"2f8aa8b3","692":"ed1c7f8a","723":"174860b2","835":"4c402c8a","956":"f3b48f5c","973":"8f3f16da"}[chunkId] + ".chunk.js";
};